// try {

// } catch(error) {
    
// }
//set price object variables
let priceObject;
let productSelectors;
if(typeof priceObject === 'undefined' || priceObject === null){
    priceObject = document.querySelector("div.price__regular > span.price-item");
}
if(typeof productSelectors === 'undefined' || productSelectors === null){
    productSelectors = document.querySelectorAll(".imatation_dropdown_product_option");
}

//set up product json objects
let productsJsonElements;
if(typeof productsJsonElements === 'undefined' || productsJsonElements === null){
    productsJsonElements = document.querySelectorAll(".product-accessory-options-json");
}


//set variant select object variables
let variantSelects;
if(typeof variantSelects === 'undefined' || variantSelects === null){
    variantSelects = document.querySelectorAll(".select__select");
}


//functioned called when selecting product from imitation drop down menu
function priceChange(event) {
    //searches through each product element
    //strips all non 0-9 characters
    //checks checkbox state and either adds or subtracks depending
    productsJsonElements.forEach(jsonElement => {
        const price = priceObject.innerText;
        strippedPrice = price.replace(/[^0-9]/g, '');
        if(event.target.checked) {
            if(event.target.value == JSON.parse(jsonElement.innerText).id){
                const addPrice = parseInt(strippedPrice, 10) + parseInt(JSON.parse(jsonElement.innerText).price, 10);
                console.log(addPrice);
                priceObject.innerText = currencyFormatter(addPrice);
            }
        } else {
            if(event.target.value == JSON.parse(jsonElement.innerText).id){
                const subtractPrice = parseInt(strippedPrice, 10) - parseInt(JSON.parse(jsonElement.innerText).price, 10);
                console.log(subtractPrice);
                priceObject.innerText = currencyFormatter(subtractPrice);
            }
        }
    });
}

//adds event selector for each product in the imitation drop down menu
productSelectors.forEach(productSelector => {
    productSelector.addEventListener('click', function(event) {
        priceChange(event);
    });
});

//price adjustment event when the variant product is changed
variantSelects.forEach(variantSelect => {
    variantSelect.addEventListener('change', (event) => {
        const productSelectors = document.querySelectorAll(".imatation_dropdown_product_option");
        let index = 0;
        productSelectors.forEach(productSelector => {
            if(productSelector.checked == true) {
                    const price = priceObject.innerText;
                    strippedPrice = price.replace(/[^0-9]/g, '');
                        const subtractPrice = parseInt(strippedPrice, 10) - parseInt(JSON.parse(productsJsonElements[index].innerText).price, 10);
                        console.log(subtractPrice);
                        priceObject.innerText = currencyFormatter(subtractPrice);
                    productSelector.checked = false;
            }
            index++;
        });
    });
});

//handles formatting price number back into currency format
function currencyFormatter(price) {
    const firstPart = price.toString().slice(0, -2); // Get all characters except the last two
    const lastTwoChars = price.toString().slice(-2); // Get the last two characters
    price = firstPart + '.' + lastTwoChars; // Concatenate with a period in between

    const usdFormatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
    }).format(price);
    console.log(usdFormatted);
    
    return usdFormatted;
}
